import { RoutePath } from '../../enums/RoutePath';

export const pcwPaths = [RoutePath.PrivateCompanyWatchlist, RoutePath.PrivateCompanyMonitorList];
